import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=12a7f418&"
import script from "./Error.js?vue&type=script&lang=js&"
export * from "./Error.js?vue&type=script&lang=js&"
import style0 from "./Error.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports